import { useState, useEffect } from 'react';
import { Common, color } from '@stockbit/ui';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import AuthCardLayout from 'global/AuthCardLayout';

import InputToken from 'features/register/InputTokenV2';
import TimerOtp from 'features/register/TimerOtp';

// state
import { selectors } from 'lib/entities/credentials';

import { formatCensorPhoneNumber } from 'utils/textFormatter';
import { InputPinContainer } from '../styled';

const { Button, Text } = Common;

interface VerifyPhoneProps {
  onVerify: (code: string) => void;
  onChangePhone: () => void;
  onResend: () => void;
  autoRedirect?: boolean;
  phoneNumber: string;
}

function VerifyPhone({
  onVerify,
  autoRedirect = true,
  onResend,
  onChangePhone,
  phoneNumber = '',
}: VerifyPhoneProps): JSX.Element {
  const [phoneTokenState, setPhoneTokenState] = useState<string>('');
  const router = useRouter();
  // request states
  const { isLoggedIn } = useSelector(selectors);

  // Check Logged In
  useEffect(() => {
    if (isLoggedIn && autoRedirect) {
      router.push('/stream');
    }
  }, [isLoggedIn, autoRedirect, router]);

  const handleVerifyClick = (phoneToken: string) => {
    // save phoneToken to state
    // for button click
    setPhoneTokenState(phoneToken);

    // Previously we auto call API when all input has been filled
    // But it also could produce an infinite loop, thus
    // we opt out that feature and make it so we call API when button is clicked
  };

  const handleOnclickBtnVerify = () => {
    // HIT API verify user
    onVerify(phoneTokenState);
  };

  return (
    <AuthCardLayout wrapperClassName="register">
      <Text size="24px" align="center" color={color.highempahis} weight="bold">
        Verification Code
      </Text>

      <Text
        size="16px"
        color={color.highgray}
        family="light"
        style={{ lineHeight: '135%' }}
      >
        Verification code has been sent to{' '}
        <b>+{formatCensorPhoneNumber(phoneNumber)}</b>
      </Text>

      <InputPinContainer>
        <InputToken onVerify={handleVerifyClick} />
        <TimerOtp onResend={onResend} />
      </InputPinContainer>

      <Button
        id="verify-otp"
        type="primary"
        height="44px"
        onClick={handleOnclickBtnVerify}
        block
        disabled={phoneTokenState?.length !== 4}
      >
        <Text family="bold" color={color.light}>
          Verification
        </Text>
      </Button>

      <div>
        <Text align="center" size="12px" color={color.black}>
          Didn&apos;t receive SMS ?
        </Text>
        <Text align="center" size="12px">
          <Text as="a" size="12px" onClick={onChangePhone}>
            Change Phone Number
          </Text>
        </Text>
      </div>
    </AuthCardLayout>
  );
}

export default VerifyPhone;
